import React from 'react';
import styled from 'styled-components';
import { Select, SelectOption } from 'components';
import { Icon, Text } from '@brokerbay/design-components';
import { buildOrgAddress } from 'utils';
import { useOrgOnboardingSelectContext } from '../../../contexts/OrgOnboardingSelectContext';

const BrokerageSelect = () => {
  const { portalConfig, selectedOrg, setSelectedOrg } =
    useOrgOnboardingSelectContext();

  return (
    <StyledSelect
      showSearch
      placeholder="Search brokerage name"
      suffixIcon={<Icon type="search" width={16} />}
      optionLabelProp="label"
      filterOption={(input, option) =>
        option.label
          .toString()
          .toUpperCase()
          .includes(input.toUpperCase().trim())
      }
      value={selectedOrg}
      onChange={value => setSelectedOrg(value)}
      data-cy="select-brokerage"
      disabled={!portalConfig}
    >
      {portalConfig?.orgs.map(org => (
        <SelectOption value={org.id} key={org.id} label={org.name}>
          <OrgNameLabel block>{org.name}</OrgNameLabel>
          <OrgAddressLabel block>
            {buildOrgAddress(org.address)[0]}
          </OrgAddressLabel>
        </SelectOption>
      ))}
    </StyledSelect>
  );
};

export default BrokerageSelect;

const StyledSelect = styled(Select)`
  width: 100%;

  // Kind of hacky; moves the suffixIcon to the left to be a prefix
  & .ant-select-arrow {
    left: 11px;
    right: auto;
    top: 44%;
  }
  & .ant-select-selector > .ant-select-selection-search,
  & .ant-select-selector > .ant-select-selection-item,
  & .ant-select-selector > .ant-select-selection-placeholder {
    padding-left: 18px;
    padding-right: 0;
  }
`;

const OrgNameLabel = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const OrgAddressLabel = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 45%;
  font-size: 12px;
  line-height: 20px;
`;
